import $ from 'jquery';
import Unit from '../Global/_Unit';
import slick from 'slick-carousel';// eslint-disable-line

class Erabikata {
  constructor(target) {
    this.clickNum = 0;
    this.modalErabikata = $('.modal__erabikata');
    this.modalClose = target.find('.remodal-close');
    this.modalSlide = $('.modal__erabikataSlide ul');
    this.list = target.find('.erabikata__3colLi');
    this.inst = target.find('[data-remodal-id=modal-erabikata]').remodal();
    this._setInit();
    this._setEvent();
  }

  _setInit() {
    this.modalErabikata
      .parents('.remodal-wrapper')
      .addClass('remodal-wrapper-erabikata');
  }

  _setSlick() {
    if (this.modalSlide.hasClass('slick-initialized')) {
      this.modalSlide.slick('unslick');
    }
    this.modalSlide
      .on('init', function (event, slick) {
        $('.modal__erabikataSlideCurrentNum').text(slick.currentSlide + 1);
        $('.modal__erabikataSlideTotalNum').text(slick.slideCount);
      })
      .slick({
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        centerMode: false,
        prevArrow: '.modal__erabikataSlidePrev',
        nextArrow: '.modal__erabikataSlideNext',
        // variableWidth: true,
        arrows: true,
        dots: false,
        swipe:false
      })
      .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.modal__erabikataSlideCurrentNum').text(nextSlide + 1);
        setTimeout(function () {
          $('.modal__erabikata .erabikata__3colLiContentInner').fadeIn();
        },300);
      });
    // this.modalSlide.slick('slickGoTo', this.clickNum);
    this.modalSlide.slick('slickGoTo', this.clickNum, true);
  }

  _goSlick() {
    // this.modalSlide.slick('slickGoTo', this.clickNum);
    this.modalSlide.slick('slickGoTo', this.clickNum, true);
  }

  _setEvent() {
    this.list.click(
      function (event) {
        if (!Unit.isPc()) {
          $('.modal__erabikata .erabikata__3colLiContentInner').hide();
          this.inst.open();
          this.clickNum = $(event.currentTarget).data('erabikata-id');
        }
      }.bind(this),
    );

    $(document).on(
      'opening',
      '.modal__erabikata',
      function () {
        // console.log('1');
        this._setSlick();
        this.modalClose.fadeIn();
      }.bind(this),
    );

    $(document).on(
      'opened',
      '.modal__erabikata',
      function () {
        this._setSlick();
        this.modalClose.fadeIn();
      }.bind(this),
    );

    $(document).on(
      'closing',
      '.modal__erabikata',
      function () {
        this.modalClose.hide();
      }.bind(this),
    );
  }
}

(() => {
  const targets = $('.erabikata');
  if (!targets.length) return;
  new Erabikata(targets);
})();
